import { render, staticRenderFns } from "./MembershipData.vue?vue&type=template&id=5988e263"
import script from "./MembershipData.vue?vue&type=script&lang=ts"
export * from "./MembershipData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports